import React, { useEffect, useState } from "react";
import styles from "./NavBarBottom.module.scss";
import { useLocation } from "react-router-dom";
import { ProjectSVG } from "./svg/ProjectSVG";
import { EventSVG } from "./svg/EventSVG";
import { TopicsSVG } from "./svg/TopicsSVG";
import { LoginSVG } from "./svg/LoginSVG";
import { IconLogoutSVG } from "../../assets/img/IconLogoutSVG";
import { IconEsportsPersonSVG } from "../../assets/img/iconEsportsPersonSVG";
import { IconTeamOwnerSVG } from "../../assets/img/IconTeamOwnerSVG";
import { getAuthToken, logoutRequest } from "../../redux/reducers/auth";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import SonicLink from "../routing/SonicLink";

type Props = {
  isLoggedIn?: boolean;
};

export const NavBarBottom: React.FC<Props> = ({ isLoggedIn }) => {
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();
  const path = useLocation().pathname;

  const [isShowNav, setIsShowNav] = useState<boolean>(false);
  const [isShowLogout, setIsShowLogout] = useState<boolean>(false);

  //pathが変わったらプロフィール、チーム選択を閉じる
  useEffect(() => {
    setIsShowNav(false);
  }, [path]);

  const logoutHandler = () => {
    if (auth_token) {
      dispatch(logoutRequest(auth_token));
    }
  };

  return (
    <div
      className={
        isShowNav
          ? `${styles["nav-show"]} ${styles["g-navbottom__menu-wrapper"]}`
          : styles["g-navbottom__menu-wrapper"]
      }
      onMouseLeave={() => setIsShowNav(false)}
    >
      <div
        className={styles["g-navbottom__menu-toggle"]}
        onClick={() => setIsShowNav(!isShowNav)}
      >
        <div
          className={
            isShowNav
              ? `${styles["nav-show"]} ${styles["g-navbottom__menu-dot"]}`
              : styles["g-navbottom__menu-dot"]
          }
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div
        className={
          isShowNav
            ? `${styles["nav-show"]} ${styles["g-navbottom__menu"]}`
            : styles["g-navbottom__menu"]
        }
      >
        <SonicLink to="/person" className={styles["g-navbottom__menu_item"]}>
          <IconEsportsPersonSVG width={40} height={40} />
          <span className={styles["g-navbottom__menu-text"]}>プロフィール</span>
        </SonicLink>
        <SonicLink to="/team" className={styles["g-navbottom__menu_item"]}>
          <IconTeamOwnerSVG width={40} height={40} />
          <span className={styles["g-navbottom__menu-text"]}>チーム</span>
        </SonicLink>
        <SonicLink to="/project" className={styles["g-navbottom__menu_item"]}>
          <ProjectSVG width={40} height={40} />
          <span className={styles["g-navbottom__menu-text"]}>プロジェクト</span>
        </SonicLink>
        <SonicLink to="/event" className={styles["g-navbottom__menu_item"]}>
          <EventSVG width={40} height={40} />
          <span className={styles["g-navbottom__menu-text"]}>イベント</span>
        </SonicLink>
        <SonicLink to="/topics" className={styles["g-navbottom__menu_item"]}>
          <TopicsSVG width={40} height={40} />
          <span className={styles["g-navbottom__menu-text"]}>トピックス</span>
        </SonicLink>
        {isLoggedIn ? (
          //imgはcssでサイズを指定
          <SonicLink
            to="/mypage"
            className={styles["g-navbottom__menu_item"]}
            onMouseEnter={() => setIsShowLogout(true)}
            onMouseLeave={() => setIsShowLogout(false)}
          >
            <LoginSVG width={40} height={40} />
            <span className={styles["g-navbottom__menu-text"]}>マイページ</span>
            {isShowLogout === true ? (
              <div className={styles["logoutModal"]}>
                <div
                  className={styles["logoutModal__item"]}
                  onClick={() => logoutHandler()}
                >
                  <IconLogoutSVG width={20} height={20} />
                  <p className={styles["logoutModal__item__text"]}>
                    ログアウト
                  </p>
                </div>
              </div>
            ) : null}
          </SonicLink>
        ) : (
          <SonicLink to="/login" className={styles["g-navbottom__menu_item"]}>
            <LoginSVG width={40} height={40} />
            <span className={styles["g-navbottom__menu-text"]}>ログイン</span>
          </SonicLink>
        )}
      </div>
    </div>
  );
};

export default NavBarBottom;
